import axios from 'axios';
import qs from 'qs';

export const getAnalyticsEvents = (params: Record<string, unknown>) =>
  axios.get(`/api/v1/analytics/events?${qs.stringify(params)}`);

export const getAnalyticsEventNames = () =>
  axios.get('/api/v1/analytics/events/names');

export const getAnalyticsTimeSeries = (params: Record<string, unknown>) =>
  axios.get(`/api/v1/analytics/events/time-series?${qs.stringify(params)}`);

export const getAnalyticsFunnel = (params: Record<string, unknown>) =>
  axios.get(`/api/v1/analytics/events/funnel?${qs.stringify(params)}`);

export const getAnalyticsRetention = (params: Record<string, unknown>) =>
  axios.get(`/api/v1/analytics/events/retention?${qs.stringify(params)}`);

export const getStudentAnalyticsEvents = (
  studentId: string,
  params: Record<string, unknown>,
) =>
  axios.get(
    `/api/v1/analytics/students/${studentId}/events?${qs.stringify(params)}`,
  );

export const getStudentAnalyticsJourney = (
  studentId: string,
  params: Record<string, unknown> = {},
) =>
  axios.get(
    `/api/v1/analytics/students/${studentId}/journey?${qs.stringify(params)}`,
  );

export const getStudentAnalyticsSessions = (
  studentId: string,
  params: Record<string, unknown> = {},
) =>
  axios.get(
    `/api/v1/analytics/students/${studentId}/sessions?${qs.stringify(params)}`,
  );

export const getStudentAnalyticsSession = (
  studentId: string,
  sessionId: string,
  params: Record<string, unknown> = {},
) =>
  axios.get(
    `/api/v1/analytics/students/${studentId}/sessions/${encodeURIComponent(
      sessionId,
    )}?${qs.stringify(params)}`,
  );

export const getAnalyticsPresets = () => axios.get('/api/v1/analytics/presets');

export const getAnalyticsDashboards = () =>
  axios.get('/api/v1/analytics/dashboards');

export const createAnalyticsDashboard = (data: Record<string, unknown>) =>
  axios.post('/api/v1/analytics/dashboards', data);

export const updateAnalyticsDashboard = (
  dashboardId: string,
  data: Record<string, unknown>,
) => axios.put(`/api/v1/analytics/dashboards/${dashboardId}`, data);

export const deleteAnalyticsDashboard = (dashboardId: string) =>
  axios.delete(`/api/v1/analytics/dashboards/${dashboardId}`);
